// Shared "agenda una reunión" offer for every service chatbot: 10 free uses of
// the service in exchange for a meeting with the school's director/coordinator.
// ponytail: plain question object reusing the existing "options" step type — no
// new component, no backend. Add an endpoint when we need to track the leads.
export const MEETING_OPTION = {
  label: "Agendar una reunión con tu colegio (+10 usos)",
  nextIndex: "meeting",
};

export const meetingQuestion = (nextQuestionIndex = "mainMessage") => ({
  name: "meeting",
  text: `<div class="text-left">
      <strong>¡Te regalamos 10 usos de este servicio!</strong><br/>
      Solo tienes que ayudarnos a agendar una reunión con el director(a) o
      coordinador(a) PIE de tu colegio.<br/><br/>
      Escríbenos a <strong><a href="mailto:contacto@redpie.cl">contacto@redpie.cl</a></strong>
      con el nombre de tu colegio y el contacto de la persona con la que
      podemos reunirnos. Apenas se concrete la reunión cargamos los 10 usos a
      tu cuenta.
    </div>`,
  type: "options",
  single_choice: true,
  answersLoaded: false,
  nextQuestionIndex,
  answers: [],
  getAnswers() {
    this.answers = [
      {
        name: "Volver al menú",
        isSelected: false,
        class: "col-md-7 col-12 my-2",
        bootstrap_classes: "text-left px-2 font-weight-bold",
        nextQuestionIndex,
      },
    ];
    this.answersLoaded = true;
    return Promise.resolve(this.answers);
  },
  routine() {},
});
